import Swiper from 'swiper';
import { Autoplay, FreeMode } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/free-mode'

const logosRow = () => {
	const elements = document.querySelectorAll('.row--logos');
	if (!elements) return;

	elements.forEach((element) => {
		const swiperElement = element.querySelector('.swiper');
		if (swiperElement) {
			const numberOfSlides = swiperElement.querySelectorAll('.swiper-slide');
			const autoscroll = swiperElement.classList.contains('autoscroll');
			let autoscrollSetting = false;
			if (autoscroll) {
				autoscrollSetting = {
					delay: 0,
					disableOnInteraction: false
				}
			}

			const swiper = new Swiper(swiperElement, {
				modules: [Autoplay, FreeMode],
				loop: numberOfSlides.length > 10,
				mousewheel: false,
				slidesPerView: 'auto',
				spaceBetween: 20,
				speed: 2500,
				breakpoints: {
					767: {
						spaceBetween: 30
					},
					1200: {
						spaceBetween: 40
					},
				},
				freeMode: {
					enabled: true,
					momentumBounce: false,
					sticky: false,
				},
				autoplay: autoscrollSetting,
			});
		}
	});
};

export default logosRow;
